import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { Popup } from './popup.model';

@Injectable({
	providedIn: 'root',
})
export class PopupService {
	readonly #http = inject(HttpClient);

	getLatestPopup(): Observable<Popup | null> {
		return this.#http.get<Popup>('/rest/popups/latest').pipe(
			map((popup) => {
				if (popup?.name && popup.description) {
					return popup;
				}

				return null;
			}),
			catchError(() => of(null))
		);
	}
}
